module.exports = __webpack_public_path__ + "static/img/tx-2.7c42bbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tx-2.png
// module id = kw3h
// module chunks = 1